module.exports = __webpack_public_path__ + "static/media/1029627.47426838.jpg";